import { useEffect } from "react";
import LegalPageLayout, { LegalHeading } from "./LegalPageLayout";

const CONTACT_EMAIL = "info@phillyfreeway.shop";

export default function Terms() {
  useEffect(() => {
    document.title = "Terms | Philadelphia Freeway";
  }, []);

  return (
    <LegalPageLayout title="Terms of Use" effectiveDate="August 1, 2026">
      <p>
        These Terms of Use govern your access to and use of the Philadelphia
        Freeway website (the "Site"). By using the Site, you agree to these
        Terms. If you do not agree, please do not use the Site.
      </p>

      <section>
        <LegalHeading>Use of the Site</LegalHeading>
        <p>
          You may browse the Site for personal, non-commercial informational
          purposes related to the Philadelphia Freeway 23rd Anniversary
          Collection. You agree to use the Site in accordance with applicable
          law and these Terms.
        </p>
      </section>

      <section>
        <LegalHeading>Merchandise Preview</LegalHeading>
        <p>
          Merchandise displayed on the Site is currently shown as a preview
          only. Online purchases are not being accepted, no prices are being
          published, and no orders can be placed through the Site at this
          time. Product photos, descriptions, and availability are subject to
          change without notice.
        </p>
      </section>

      <section>
        <LegalHeading>Intellectual Property</LegalHeading>
        <p>
          All content on the Site — including but not limited to the
          Philadelphia Freeway name, the 23rd Anniversary logo, the
          FTA × Planes marks, photography, video, artwork, album artwork,
          tracklist metadata, and written copy — is the property of its
          respective owner and is protected by copyright, trademark, and
          related laws. You may not copy, republish, download for commercial
          use, distribute, or exploit any Site content without prior written
          permission.
        </p>
      </section>

      <section>
        <LegalHeading>Prohibited Conduct</LegalHeading>
        <p>You agree not to:</p>
        <ul className="list-disc pl-5 space-y-2">
          <li>Use the Site in any way that violates any applicable law or regulation.</li>
          <li>Attempt to interfere with, disrupt, or gain unauthorized access to any part of the Site, its servers, or the databases it relies on.</li>
          <li>Scrape, harvest, or otherwise collect information about the Site or its users through automated means without permission.</li>
          <li>Impersonate any person or misrepresent your affiliation with the Philadelphia Freeway project.</li>
          <li>Submit false or misleading information — including invalid email addresses submitted through the signup form.</li>
        </ul>
      </section>

      <section>
        <LegalHeading>Third-Party Links</LegalHeading>
        <p>
          The Site may include links to third-party websites, such as the
          FreeFest event page or the venue's own site. Those pages are
          operated by others and are governed by their own terms and privacy
          practices. We are not responsible for the content, accuracy, or
          policies of third-party sites.
        </p>
      </section>

      <section>
        <LegalHeading>Disclaimers</LegalHeading>
        <p>
          The Site is provided "as is" and "as available", without warranties
          of any kind, whether express or implied, including warranties of
          merchantability, fitness for a particular purpose, non-infringement,
          or uninterrupted availability. We do not guarantee that the Site
          will be error-free, secure, or continuously available.
        </p>
      </section>

      <section>
        <LegalHeading>Limitation of Liability</LegalHeading>
        <p>
          To the fullest extent permitted by law, in no event shall the
          Philadelphia Freeway project, its partners, or its collaborators be
          liable for any indirect, incidental, special, consequential, or
          punitive damages arising from your access to or use of, or inability
          to use, the Site or any content on it.
        </p>
      </section>

      <section>
        <LegalHeading>Changes to These Terms</LegalHeading>
        <p>
          We may update these Terms from time to time. When we do, we will
          revise the effective date at the top of this page. Your continued
          use of the Site after the update means you accept the revised
          Terms.
        </p>
      </section>

      <section>
        <LegalHeading>Contact</LegalHeading>
        <p>
          Questions about these Terms can be sent to{" "}
          <a href={`mailto:${CONTACT_EMAIL}`} className="text-[#F4C10A] underline underline-offset-2 hover:text-[#FFD22C]">
            {CONTACT_EMAIL}
          </a>
          .
        </p>
      </section>
    </LegalPageLayout>
  );
}
